import { ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums';
import type { IProduct } from '@inter-ikea-kompis/types';

import LawLabelLinkEnum from '../enums/LawLabelLinkEnum.js';

export default class LawLabelUtility {
	/**
	 * Get a law label link text
	 *
	 * @param product The product.
	 * @returns LawLabelLinkEnum.LABEL_LAW_LABEL_EN or LawLabelLinkEnum.LABEL_LAW_LABEL_ES or an empty string.
	 */
	public static getLawLabelLinkText(product: IProduct): LawLabelLinkEnum | null {
		const labelText = product.content?.complianceTechnical?.find(
			(label) =>
				label.headingType === ProductComplianceTechnicalHeadingTypeEnum.hyperlink &&
				(label.text === LawLabelLinkEnum.LABEL_LAW_LABEL_EN ||
					label.text === LawLabelLinkEnum.LABEL_LAW_LABEL_ES)
		)?.text;

		return (labelText as LawLabelLinkEnum) || null;
	}
}
